<template>
  <div class="page">
    <div class="page-box">
      <div class="top-title">
        <div class="title-text">
          <div class="title-En">Hello！</div>
          <div class="title-zh">欢迎使用WIFI管理端</div>
        </div>
        <div class="kf" @click="toKefu()">
          <img src="@/assets/newUser/kefu.gif" alt="">
        </div>
      </div>
      <div class="from-sumbit">
        <div class="titleBox">
          <div class="textsox">
            <div class="title">业务办理</div>
            <div class="lines"></div>
          </div>
        </div>
        <van-cell-group inset>
          <van-field v-model="readonly" readonly left-icon="volume-o" />
        </van-cell-group>
        <van-cell-group inset>
          <van-field placeholder="请输入设备上的号码" left-icon="gem-o" v-model="iccid" />
        </van-cell-group>
        <button class="btn btn-primary" @click="onSubmit()">登录设备</button>
      </div>
    </div>
  </div>
</template>
<script>
import { Dialog } from "vant";
import { wxRequest } from "@/api/user.js";
export default {
  data() {
    return {
      homeTitle: '注意：更换设备会导致机卡分离，请勿随意操作更换设备！若需更换请联系在线客服。',
      code: "",
      iccid: "",
      height: null,
      readonly: '请点击右上角三个点，收藏该页面',
      userPhone: localStorage.getItem("userPhone"),
    };
  },
  created() {
    var source = "wx18b33905435d410b";
    localStorage.setItem("appid", source);
    localStorage.setItem("isHeadquarterAppid", false);
    var appid = source || process.env.VUE_APP_APPID;
    if (this.$route.query.iccid) {
      this.iccid = this.$route.query.iccid;
    }
    this.height = document.documentElement.clientHeight - 550;
    var redirectUrl = window.location.href;
    var index = redirectUrl.indexOf("code");
    redirectUrl = encodeURIComponent(redirectUrl);

    var ali = "ali";//不授权 默认支付宝
    var ua = window.navigator.userAgent.toLowerCase();
    //通过正则表达式匹配ua中是否含有MicroMessenger字符串
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      ali = "wx";
    }
    localStorage.setItem("htmlType", ali);

    this.code = "1";
    /**
     * 
    if (ali == 'ali') {
      this.code = "1";
    } else if (index < 0) {
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxb4bff16244869bed&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_base#wechat_redirect`;
    } else {
      var search = window.location.search;
      console.log("search", search);
      var startIndex = search.indexOf("code");
      var endIndex = search.indexOf("&", startIndex);
      var str = search.slice(startIndex, endIndex);
      var code = str.slice(str.indexOf("=") + 1);
      this.code = code;
      if (this.$route.query.iccid) {
        this.iccid = this.$route.query.iccid;
      } else {
        this.iccid = localStorage.getItem("recordLoginText");
      }
      localStorage.setItem("wxCode", code);
    }

     */
    this.$store.commit("setIsHeadquarterAppid", "true");
    localStorage.setItem("isHeadquarterAppid", true);
    if (this.$route.query.iccid) {
      this.iccid = this.$route.query.iccid;
    } else {
      this.iccid = localStorage.getItem("recordLoginText");
    }
  },
  methods: {
    scanChange() {
      //  Dialog.alert({message: '扫一扫功能，暂未开放！'});
    },
    toActiveTv() {
      window.location.href = "http://active.519liuliang.com/active.mp4";
    },
    toKefu() {
      window.location.href = "http://wx.519liuliang.com/#/newUser/simKefu";
    },
    onSubmit() {
      const recordLoginText = this.iccid;
      const data = {
        requestId: this.iccid,
        code: "1",
        isCode: 1,
      };
      localStorage.setItem("recordLoginText", recordLoginText);
      wxRequest("sim/bind", data, "get").then((res) => {
        if (res.data.code === "200") {
          const record = res.data.data;
          const iccid = record.iccid;
          localStorage.setItem("firstVipLogin", 0);
          localStorage.setItem("isToWxKefu", record.isToWxKefu);
          localStorage.setItem("isShieldAgent", record.isShieldAgent);

          localStorage.setItem("toBuyPkgId", record.toBuyPkgId);
          localStorage.setItem("isShowApp", record.isShowApp);
          localStorage.setItem("isShowAppMenu", record.isShowApp);

          localStorage.setItem("newUserPhone", record.userPhone);
          localStorage.setItem("newLoginText", recordLoginText);


          localStorage.setItem("PayImgUrl", record.imgUrl);
          localStorage.setItem("payPrice", record.payPrice);

          localStorage.setItem("isAutoHome", 1); // 1表示自动跳转到 firstHome
          localStorage.setItem("isCode", true);
          localStorage.setItem("mobile", record.mobile);
          localStorage.setItem("userPhone", record.userPhone); // 用户绑定得手机号
          localStorage.setItem("supplierTypeName", record.supplierTypeName);
          localStorage.setItem("wxHeadImg", record.wxHeadImg);
          localStorage.setItem("wxNickName", record.wxNickName);
          localStorage.setItem("recordLoginText", recordLoginText);
          localStorage.setItem("supplierName", record.supplierName);
          localStorage.setItem("intoNo", record.intoNo);
          localStorage.setItem("salePrice", record.salePrice);
          localStorage.setItem("iccid", record.iccid);
          localStorage.setItem("openId", record.openId);
          localStorage.setItem("virtualNo", record.virtualNo);
          localStorage.setItem("isBindPhone", record.isBindPhone);
          localStorage.setItem("tuiPrice", record.tuiPrice); // 赠送金余额
          localStorage.setItem("firstLogin", 1);
          localStorage.setItem("basePkgGroup", record.basePkgGroup);
          this.$store.state.recordLoginText = recordLoginText;
          this.$store.state.supplierCode = res.data.data.supplierCode;
          this.$store.state.iccid = iccid;
          this.$store.commit("setIccid", iccid);
          localStorage.setItem("newHome", 1);
          this.$store.state.newHome = 1;
          this.$store.state.isBindPhone = record.isBindPhone;
          this.$store.state.intoNo = record.intoNo;
          sessionStorage.setItem("intoNo", record.intoNo);

          this.$router.replace("/user/home");
        } else if (res.data.code === "588") {
          window.location.href = 'http://1.xiaoxiang.xianyiwulian.com/wap/pages/index/cardLinks?card=' + this.iccid + "&type=1";
        } else {
          Dialog.alert({ title: "提示", message: res.data.message });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped> .page {
   width: 100%;
   min-height: 100vh;
   display: flex;
   flex-wrap: wrap;
   align-content: flex-start;

   .page-box {
     width: 100%;
     background: url('~@/assets/newUser/bgs.png');
     background-size: 100% 325px;

     .top-title {
       width: 100%;
       height: auto;
       padding: 52px 27px 36px;
       box-sizing: border-box;
       display: flex;
       justify-content: space-between;
       align-items: center;
     }

     .title-text {
       width: calc(100% - 70px);
       color: #1d2129;
       font-size: 25px;
       font-weight: 700;

       .title-zh {
         margin-top: 5px;
       }
     }

     .kf {
       width: 70px;
       height: 70px;

       img {
         width: 100%;
         height: 100%;
       }
     }
   }

   .from-sumbit {
     height: calc(100vh - 160px);
     width: 100%;
     background-color: #fff;
     border-radius: 15px 15px 0 0;
     padding: 22px 26px;
     box-sizing: border-box;

     .titleBox {
       display: flex;
       flex-wrap: wrap;
       justify-content: center;

       .textsox {
         width: auto;
         display: flex;
         flex-wrap: wrap;
         justify-content: center;

         .title {
           width: 100%;
           text-align: center;
           font-size: 14px;
           color: #333;
         }

         .lines {
           width: 100%;
           height: 5px;
           border-radius: 3px;
           margin-top: 4px;
           background: linear-gradient(to right, #3c9cff, #9acafc);
         }
       }
     }

     .van-cell-group {
       width: 100%;
       height: 48px;
       margin-top: 30px;

       .van-cell {
         height: 48px;
         line-height: 48px;
         font-size: 16px;
         color: #333;
         background-color: #f7fafc;
         padding: 0 12px;
         border-radius: 5px;

         .van-field__control {
           height: 100%;
           line-height: inherit;
           font-size: 16px;
           color: #333;
         }

         ::v-deep .van-field__body {
           padding-left: 6px;
         }

         ::v-deep .van-icon {
           font-size: 20px;
           /* color: #3c9cff; */
         }

         ::v-deep .van-icon-gem-o,
         ::v-deep .van-icon-volume-o {
           font-size: 20px;
           padding-right: 8px;
           border-right: 1px solid #f0f0f0;
         }
       }

       &::after {
         border: none;
       }
     }

     .btn-primary {
       width: 100%;
       height: 45px;
       border-radius: 5px;
       margin-top: 35px;
       font-size: 16px;
       line-height: inherit;
       color: #fff;
       border: none;
       background: linear-gradient(120deg, rgb(52, 145, 250), rgb(170, 210, 255), rgb(107, 179, 255), rgb(159, 212, 253));
     }
   }
 }</style>
